export function handleBigNumbers(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
}

export function validateEmail(email) {
  if (email.length === 0) return "Empty Field";
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!re.test(String(email).toLowerCase())) return "Email not valide";
  return "";
}
// validate username safari
export function validUsername(username) {
  if (username.length === 0) return "Empty Field";
  if (username.length < 3) return "Username must be at least 3 characters";
  if (username.length > 20) return "Username must be less than 20 characters";
//   const re = /^[a-zA-Z0-9_]*$/;
//   if (!re.test(String(username).toLowerCase())) return "Username not valid";
  return "";
}

// validate login field (can be username or email)
export function validLoginField(loginField) {
  if (loginField.length === 0) return "Empty Field";
  
  // Check if it looks like an email
  if (loginField.includes('@')) {
    // Validate as email
    return validateEmail(loginField);
  } else {
    // Validate as username
    if (loginField.length < 3) return "Username must be at least 3 characters";
    if (loginField.length > 20) return "Username must be less than 20 characters";
  }
  
  return "";
}
// export function validUsername(username) {
//   if (username.length === 0) return "Empty Field";
//   if (username.length < 3) return "Username must be at least 3 characters";
//   if (username.length > 20) return "Username must be less than 20 characters";
//   if (!/^[a-zA-Z0-9]+$/.test(username))
//     return "Username must contain only letters and numbers";
//   return "";
// }
// export function validUsername(username) {
//   if (username.length === 0) return "Empty Field";
//   const reg = new RegExp("^(?=.{4,20}$)(?![-.])(?!.*[-.]{2})[a-zA-Z0-9._-]+(?<![.])$");
//   if (!reg.test(String(username).toLowerCase())) return "Username not valide";
//   return "";
// }

// Example: 215 will return +99
export function To2Digits(nbr) {
  if (nbr > 99) return "+99";
  return nbr.toString();
}

export function validPassword(password) {
  if (password.length === 0) return "Empty Field";
  if (password.length < 8) return "Password must be 8 characters longer!";
  return "";
}

export function checkComfirmPassword(password, confirmPassword) {
  if (confirmPassword.length === 0) return "Empty Field";
  if (password !== confirmPassword) return "Confirm password is deffirent";
  return "";
}

export const checkUrl = (url) => {
  if (!url.includes("www")) url = `www.${url}`;
  if (url) {
    if (url.includes("http://") || url.includes("https://")) return url;
    else return `http://${url}`;
  }
};

export const checkPaypal = (url) => {
  if (url.includes("paypal.me") || url.includes("paypalme")) return checkUrl(url);
  else return "https://paypal.me/" + url;
};

//check facebook profile url
export const checkFacebook = (url) => {
  if (url.includes("facebook.com")) return checkUrl(url);
  else return "https://facebook.com/" + url;
}

//check twitter profile url
export const checkTwitter = (url) => {
  if (url.includes("twitter.com")) return checkUrl(url);
  else return "https://twitter.com/" + url;
}

//check instagram profile url
export const checkInstagram = (url) => {
  if (url.includes("instagram.com")) return checkUrl(url);
  else return "https://instagram.com/" + url;
}

//check youtube profile url
export const checkYoutube = (url) => {
  if (url.includes("youtube.com/c/")) return checkUrl(url);
  else return "https://youtube.com/c/" + url;
}